* HTML document, ASCII text, with CRLF line terminators
<template>
	<div>
		<div class="w3-row">
			<div class="w3-col w3-half">
				<content-header v-bind:title="$t(ftitle)"></content-header>
			</div>

			<div class="w3-col flow-padding-top w3-large" v-if="notifications"
			     :class="isPluginDH(plugin) ? 'w-50pc' : 'w-30pc'">
            <span
		            class="fa fa-stack w3-large cursor-pointer w3-right flow-form-action active w3-ripple w3-text-red"
		            :title="$t('removeNotifications')"
		            @click="removeAllNotifications">
                <i class="fa fa-stack-2x fa-circle  w3-text-white"></i>
                <i class="fa fa-stack-1x fa-bell fa-inverse w3-text-red w3-xlarge"></i>
            </span>
			</div>

			<div class="w3-col w-20pc w3-right flow-content-actions-header flow-margin-bottom pad-right-10" v-if="!isPluginDH(plugin)">
				<div class="w3-col flow-padding-top w3-right device-select">
					<flow-select :items="groups"
					             :valueKey="'displayName'"
					             :valueKeyIndex="'id'"
					             :preSelectedItem="selectedGroup"
					             :callback="setSelectedGroup">
					</flow-select>
				</div>
			</div>
		</div>

		<div v-if="selectedGroup && !selectedGroup.id && !isPluginDH(plugin)">
			<h5 class="flow-blue-color w3-center w3-padding">
				<span class="font-weight-bold w3-margin-right w3-hover-opacity-off flow-blue-color">
					{{ $t('selectDevice') }}
				</span>
			</h5>
		</div>

		<div v-else>
			<dhOverview v-if="isPluginDH(plugin)"></dhOverview>
			<miOverview v-else-if="!isPluginDH(plugin) && renderComponent" :selectedGroup="selectedGroup.id"
			            :groups="groups"></miOverview>
		</div>
	</div>

</template>

<script>
import Vue from 'vue';
import {EventBus} from "@/main";
import ContentHeader from "@/components/common/ContentHeader";
import Loading from "@/components/common/Loading";
import FlowSelect from "@/components/common/FlowSelect";
import miOverview from "@/components/status-overview/mi/mi.vue";
import dhOverview from "@/components/status-overview/dh/dh.vue";

const frc = Vue.prototype.$frc;

export default {
	name: "StatusOverview",
	components: {ContentHeader, Loading, miOverview, dhOverview, FlowSelect},
	props: ['ftitle'],
	data: function () {
		return {
			renderComponent: true,
			notifications: false,
			plugin: '',
			groups: [],
			selectedStatusOverviewGroupId: undefined,
			selectedGroup: {displayName: this.$t('chooseDevice')},
		}
	},
	beforeDestroy() {
		EventBus.$off("checkNotifications");
	},
	mounted() {
		this.selectedStatusOverviewGroupId = Vue.getCookie('selectedStatusOverviewGroupId');
		this.getGroupsInWard();
		EventBus.$on("checkNotifications", (notifications) => {
			this.notifications = notifications;
		});
	},
	created() {
		this.plugin = Vue.prototype.$currentWard.uisettings.plugin;
	},
	methods: {
		setSelectedGroup(_group) {
			this.selectedGroup = _group;
			if (_group.id) {
				Vue.prototype.$changedGroup = true;
				Vue.setCookie('selectedStatusOverviewGroupId', _group.id, 16 * 60);
				EventBus.$emit("changedGroup", _group.id);

				// Remove mi component from the DOM
				this.renderComponent = false;
				this.$nextTick(() => {
					// Add mi component back in
					this.renderComponent = true;
				});
			}
		},
		getGroupsInWard() {
			let app = this;
			let wardId = Vue.prototype.$currentWard.id;
			frc.getConsultationGroupsInWard(wardId).then(function (res) {
				let groups = res.data;
				for (let i in groups) {
					let group = groups[i];
					if (app.selectedStatusOverviewGroupId === group.id) {
						app.selectedGroup = group;
					}

					if (group.type && group.type !== 'consultation') {
						app.groups.push(group);
						Vue.sortByKey(app.groups, 'displayName');
					}
				}
			});
		},
		removeAllNotifications() {
			this.notifications = false;
			EventBus.$emit("removeAllNotifications", this.plugin);
		},
	}
}
</script>

<style>
.device-select .flow-select-list-selected {
	border: 3px solid var(--flow-blue-color) !important;
	display: flex;
	align-items: center;
}

.device-select .flow-select-list-selected p {
	font-weight: bold;
	font-size: 2vh;
}
</style>